export default __webpack_public_path__ + "static/media/chef-2.2bcbe900.jpeg";